import * as S from './index.style'
import { Map } from '@styled-icons/material-rounded/Map'
import theme from 'styles/theme'

export type NomeTerrenoProps = {
  /** Propriedade que indica o nome do terreno a ser exibido */
  nomeTerreno?: string

  /** Propriedade que indica a cor do icone do componente*/
  cor?: 'cinza' | 'verde'
}

/** Componente responsável por exibir o nome do terreno com o icone de mapa */
const NomeTerreno: React.FC<NomeTerrenoProps> = ({ nomeTerreno, cor = 'cinza' }) => {
  const color = cor == 'cinza' ? theme.colors.gray : theme.colors.primary

  return (
    <S.Wrapper>
      <Map data-cy="iconeMapa" size={24} color={color} />
      <S.Title data-cy="labelNomeTerreno" color={color}>
        {nomeTerreno}
      </S.Title>
    </S.Wrapper>
  )
}

export default NomeTerreno
